<template>
  <svg width="32" height="32" viewBox="0 0 32 32">
    <path
      d="M16 3.333a7 7 0 0 1 6.994 6.712l.006.288V14l2.333.001v14.667H6.667V14H9v-3.667a7 7 0 0 1 7-7zM16 18a2 2 0 0 0-1.452 3.376l.118.114v3.177h2.667V21.49A2 2 0 0 0 16 18zm0-12.667a5 5 0 0 0-4.993 4.735l-.007.265V14h10v-3.666a5 5 0 0 0-5-5z"
      fill="#737380"
      fill-rule="evenodd"
    />
  </svg>
</template>
